module.exports = __webpack_public_path__ + "static/media/icon_startup_consulting.8cebf51a.svg";